import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=1d368780"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d368780')) {
      api.createRecord('1d368780', component.options)
    } else {
      api.reload('1d368780', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=1d368780", function () {
      api.rerender('1d368780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Plants/layout.vue"
export default component.exports